export const firstBlockId = 2;

export const HOUSE_LOOKS = {
  EXTERIOR: "Exterior",
  INTERIOR: "Interior",
};
